import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrDeviceFieldAggrResponse } from '@/api/routes/stat/types';

import { fetchStaticAggrDeviceSumAdTimeFieldAggr } from '../actionCreators';

interface InitialState {
  aggrByAvgField: AggrDeviceFieldAggrResponse,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  aggrByAvgField: [],
  isLoading: false,
  error: '',
};

export const staticAggrDeviceBySumAdTimeFieldSlice = createSlice({
  name: 'staticAggrDeviceBySumAdTimeFieldSlice',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchStaticAggrDeviceSumAdTimeFieldAggr.fulfilled.type]:
      (state, action: PayloadAction<AggrDeviceFieldAggrResponse>) => {
        state.isLoading = false;
        state.error = '';
        state.aggrByAvgField = action.payload;
      },
    [fetchStaticAggrDeviceSumAdTimeFieldAggr.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchStaticAggrDeviceSumAdTimeFieldAggr.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default staticAggrDeviceBySumAdTimeFieldSlice.reducer;
